module.exports = __webpack_public_path__ + "static/media/mythic_booster.44ce9377.webp";